import { AuthStateEnum } from 'graph/globalTypes'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const AUTHENTICATED_ACCESS_PATHS = [
  '/inbox',
  '/settings',
  '/upgrade',
  '/homepage',
  '/dashboard',
  '/get-started/location',
  '/get-started/sponsorship',
  '/get-started/services',
  '/get-started/rate',
  '/get-started/details',
  '/get-started/plans',
  '/get-started/payment',
]

export const ALLOWED_AUTO_LOGGED_IN_PATHS = [
  '/settings/notifications',
  '/inbox',
  '/homepage',
  '/dashboard',
]

export const NOTIFICATIONS_UNSUBSCRIBE_PATH = '/settings/notifications'

export const SUBSCRIBED_ACCESS_PATHS = [
  '/settings/payments/change-card',
  '/settings/payments/history',
  '/settings/payments/change-plan',
  '/settings/payments/cancel',
]

export const mustConfirmPassword = (path: string, authState: AuthStateEnum) => {
  const isAuthenticatedPath = AUTHENTICATED_ACCESS_PATHS.find((p) => path.startsWith(p))
  const isAllowedAutoLoggedInPath = ALLOWED_AUTO_LOGGED_IN_PATHS.find((p) => path.startsWith(p))
  const isNotificationsUnsubscribePath = path.startsWith(NOTIFICATIONS_UNSUBSCRIBE_PATH)

  const confirmForAutologin =
    authState === AuthStateEnum.AUTO_LOGGED_IN && isAuthenticatedPath && !isAllowedAutoLoggedInPath

  const confirmForDigest =
    authState === AuthStateEnum.NOTIFICATIONS_UNSUBSCRIBE &&
    isAuthenticatedPath &&
    !isNotificationsUnsubscribePath

  return confirmForAutologin || confirmForDigest
}

export function useConfirmPasswordGate(authState: AuthStateEnum) {
  const router = useRouter()

  useEffect(() => {
    if (mustConfirmPassword(router.asPath, authState)) {
      router.push(`/confirm-password?next=${encodeURIComponent(router.asPath)}`)
    }
  }, [router.asPath])
}
